import PropTypes from 'prop-types';

export const actionPropType = PropTypes.shape({
  href: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
});

export const heroContentPropType = PropTypes.shape({
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  primaryCtaLabel: PropTypes.string,
});

export const productPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  department: PropTypes.string,
  subcategory: PropTypes.string,
  subdivision: PropTypes.string,
  sizeType: PropTypes.string,
  brand: PropTypes.string,
  image: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  basePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  originalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  description: PropTypes.string,
  details: PropTypes.string,
  reviews: PropTypes.string,
  faqs: PropTypes.string,
  summary: PropTypes.string,
  tagline: PropTypes.string,
  isHotSale: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  sizes: PropTypes.arrayOf(PropTypes.string),
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
    })
  ),
});

export const slidePropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  eyebrow: PropTypes.string,
  image: PropTypes.string,
});

export const vector3PropType = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  z: PropTypes.number.isRequired,
});

export const numberRefPropType = PropTypes.shape({
  current: PropTypes.number,
});

export const pointerPropType = PropTypes.arrayOf(PropTypes.number);
